import React from 'react';
import { Grid, FormControl, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import NCRFormHeading from '../NCRFormHeading';
import NCRFormLabel from '../NCRFormLabel';
import NCRMultilineTextfields from '../NCRMultilineTextfields';

export default function ClosureVerification({ content, onChange }) {

  const theme = createTheme({
    components: {
      MuiSelect: {
        styleOverrides: {
          select: {
            fontSize: "14px",
            fontWeight: 400,
            color: "rgba(84, 84, 84, 1)",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&::placeholder": {
              fontSize: "14px",
              fontWeight: 400,
              color: "rgba(84, 84, 84, 1)",
              opacity: 1,
            },
          },
        },
      },
    },
  });

  const [selectedValue, setSelectedValue] = React.useState(content.formData?.is_ncr_ready_for_closure || 'Yes');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (content.label === 'closure' && name === 'is_ncr_ready_for_closure') {
      setSelectedValue(value);
      onChange({ selected_value: value });
    }
    onChange({ [name]: value });
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box>
          <Box sx={{ p: 3, mb: 2 }}>
            <Box>
              <NCRFormHeading isRequired={true}>Closure Verification - Awaiting for approval</NCRFormHeading>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Box sx={{ mb: 2 }}>
                <Grid container spacing={2} xs={12} sm={12}>
                  <Grid item xs={12} sm={4}>
                    <NCRFormLabel>
                      Is the NC ready for closure?
                    </NCRFormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <FormControl>
                      <RadioGroup
                        row
                        name="is_ncr_ready_for_closure"
                        onChange={handleInputChange}
                        value={content.label === 'closure' ? selectedValue : content.formData?.is_ncr_ready_for_closure || 'Yes'}
                      >
                        <FormControlLabel disabled={content.inputDisable} value="Yes" control={<Radio />} label="Yes" />
                        <FormControlLabel disabled={content.inputDisable} value="No" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid item xs={4}>
                <NCRFormLabel isRequired={true} sx={{ mb: 3 }} >Comments for closure:</NCRFormLabel>
              </Grid>
              <Grid item xs={8}>
                <NCRMultilineTextfields
                  name="comments_for_closure"
                  value={content.formData.comments_for_closure || ""}
                  onChange={handleInputChange}
                  disabled={content.inputDisable}
                  error={!!content?.errors?.comments_for_closure}
                  placeholder={!content.inputDisable ? 'Enter your comments' : 'No data entered'}
                />
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1, mt: 2 }}>
              <Grid container spacing={2} xs={11} sm={11} alignItems="center">
                <Grid item xs={4}>
                  <NCRFormLabel isRequired={selectedValue === 'Yes'}>
                    COPQ (Cost of Poor Quality)
                  </NCRFormLabel>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    size="small"
                    name="copq"
                    type="number"
                    sx={{ size: 'small', width: 180 }}
                    disabled={content.inputDisable}
                    error={selectedValue === 'Yes' ? !!content?.errors?.copq : false}
                    placeholder={!content.inputDisable ? 'Enter COPQ value' : 'No data entered'}
                    onChange={handleInputChange}
                    value={content.formData.copq || ''}
                    min={0}
                    onKeyDown={(e) => {
                      if (["-", "e", "E"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const pastedData = e.clipboardData.getData('text');
                      // Remove any non-numeric characters except decimal point
                      const sanitized = pastedData.replace(/[^0-9.]/g, '');
                      // Ensure only one decimal point
                      const parts = sanitized.split('.');
                      const cleanValue = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : sanitized;
                      if (pastedData !== cleanValue) {
                        e.preventDefault();
                        onChange({ copq: cleanValue });
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </ThemeProvider >
    </>
  );
};
